import { render, staticRenderFns } from "./HirebotPromptPost.vue?vue&type=template&id=149a599f&scoped=true&"
import script from "./HirebotPromptPost.vue?vue&type=script&lang=js&"
export * from "./HirebotPromptPost.vue?vue&type=script&lang=js&"
import style0 from "./HirebotPromptPost.vue?vue&type=style&index=0&id=149a599f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149a599f",
  null
  
)

export default component.exports